import React from 'react';
import PropTypes from 'prop-types';

import User from './user';

export class Users extends React.Component {
  static propTypes = {
    controlIcon: PropTypes.object.isRequired,
    emptyMessage: PropTypes.string,
    users: PropTypes.array.isRequired,

    onSelect: PropTypes.func.isRequired
  }

  render() {
    return (
      <div className="panel-body">
        {this.renderEmptyMessage()}
        {this.renderUsers()}
      </div>
    );
  }

  renderEmptyMessage() {
    if (this.props.users.length > 0) {
      return null;
    }

    return (
      <h2 className="text-center text-muted">
        {this.props.emptyMessage}
      </h2>
    );
  }

  renderUsers() {
    return (
      <ul>
        {this.props.users.map(user => (
          <User
            controlIcon={this.props.controlIcon}
            key={user.id}
            user={user}
            onSelect={this.props.onSelect}
          />
        ))}
      </ul>
    );
  }
}

export default Users;
